import generateRender from 'shared/utils/generateRender';
import DefaultMessageItem from './DefaultMessageItem';

const MessageItem = generateRender({
  default: DefaultMessageItem,
});

export default MessageItem;

